module.exports = require("natural-compare-lite");


//////////////////
// WEBPACK FOOTER
// external "natural-compare-lite"
// module id = 20
// module chunks = 0